import { services } from '@ambita/ambita-components-core';

services.i18n.registerTranslations('common', {
  nb: {
    loginRequired: 'Vennligst logg inn'
  },
  'en-us': {
    loginRequired: 'Login required'
  }
});
